import { render, staticRenderFns } from "./Konto.vue?vue&type=template&id=60b1a3c0&scoped=true&"
import script from "./Konto.vue?vue&type=script&lang=js&"
export * from "./Konto.vue?vue&type=script&lang=js&"
import style0 from "./Konto.vue?vue&type=style&index=0&id=60b1a3c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b1a3c0",
  null
  
)

export default component.exports